import React, {Component} from 'react'
import BriefingToolbar from './Toolbar'
import BriefingTable from './BriefingTable'
import {openUrl} from 'shared/utils/openUrl'

export default class Products extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            flightId: this.props.match.params.flightId
        }

        this.actions = {
            onSelectDocument: (params) => this.onSelectDocument(params),
            onSelectAllDocuments: (params) => this.onSelectAllDocuments(params),
            onDisplayProduct: (params) => this.onDisplayProduct(params),
            onDisplayMergeProducts: () => this.onDisplayMergeProducts(),
            onDownloadZipProducts: () => this.onDownloadZipProducts(),
            onDownloadEFF: () => this.onDownloadEFF(),
        }
    }

    render() {
        return (
            <React.Fragment>
                <BriefingToolbar actions={this.actions} selectedIds={this.props.selectedIds}
                                 loadingButtons={this.props.loadingToolbarButtons}/>
                <BriefingTable actions={this.actions} data={this.props.data} isLoading={this.props.isLoading}
                               selectedIds={this.props.selectedIds} loadingIds={this.props.loadingIds}
                />
            </React.Fragment>
        )
    }

    componentDidMount() {
        this.onGetProductList(this.state.flightId)
    }

    componentWillUnmount() {
        if (this.props.blobUrl !== undefined)
            URL.revokeObjectURL(this.props.blobUrl)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.blobUrl !== undefined &&
            nextProps.blobUrl !== this.props.blobUrl) {
            openUrl(nextProps.blobUrl)
        }
    }

    onGetProductList(params) {
        this.props.actions.getProductList(params)
    }

    onSelectDocument(params) {
        this.props.actions.selectDocument(params)
    }

    onSelectAllDocuments(params) {
        this.props.actions.selectAllDocuments(params)
    }

    onDisplayProduct(params) {
        this.props.actions.getProduct(params)
    }

    onDisplayMergeProducts() {
        this.props.actions.getMergedProducts(this.props.selectedIds)
    }

    onDownloadZipProducts() {
        this.props.actions.getZippedProducts(this.props.selectedIds)
    }

    onDownloadEFF() {
        this.props.actions.getEFF(this.state.flightId);
    }
}


// WEBPACK FOOTER //
// ./src/screens/briefing/products/components/index.js